import React, {useState, useEffect} from 'react';
import {getMostActiveRealtors} from "../../../models/user";
import RealtorsSlider from "./realtors_slider";
import {isEmpty} from "@helpers/helpers";

const MostActiveRealtor = ({city_id, mostActiveRealtorsLists = [], last_week = false, sectionClassName}) => {
    const [activeRealtors, setActiveRealtors] = useState([]);

    useEffect(() => {
        const activeRealtorsContainer = document.querySelector('.js-active-realtors-container');

        if (!isEmpty(activeRealtorsContainer)) {
            activeRealtorsContainer.classList.remove('d-none');
        }

        getMostActiveRealtors(city_id, 12, last_week).then(result => {
            setActiveRealtors(result.realtors);

            if (isEmpty(result.realtors) || result.realtors.length < 1) {
                const activeRealtorsContainer = document.querySelector('.' + sectionClassName);

                if (!isEmpty(activeRealtorsContainer)) {
                    activeRealtorsContainer.classList.add('d-none');
                }
            }
        });
    }, [city_id]);

    return (
        <RealtorsSlider realtors={activeRealtors.length ? activeRealtors : mostActiveRealtorsLists}/>
    );
};

export default MostActiveRealtor;
